import { ChevronDown } from 'lucide-react';
import { useState, useEffect } from "react";
import { AnimatedText, AnimatedTitle } from "@/components/ui/AnimatedText";
import LuxuryCard from "@/components/ui/LuxuryCard";
import { apiFetch } from "@/utils/api";
import { useSEO } from "@/utils/useSEO";
import { useTranslation } from "react-i18next";
import { mockRooms } from "@/utils/roomsData";

export default function Accommodation() {
  const { t } = useTranslation();
  useSEO(
    "Accommodation",
    "Explore our luxury villas and suites at Patal Kikian Villas Sidemen. From the Deluxe Bungalow with infinity pool to the Private Pool Villa with panoramic Mount Agung views, each room is designed for an unforgettable Bali experience."
  );
  const [villas, setVillas] = useState<any[]>(mockRooms);

  return (
    <>
      <section className="relative min-h-[100dvh] w-full flex items-center justify-center">
        <div className="absolute inset-0">
          <img src="/media/patal-kikian-hero-banner.webp" alt="Rooms Background" className="w-full h-full object-cover opacity-85" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
        </div>
        
        <div className="relative z-10 text-center px-4 mt-20">
          <AnimatedText delay={0.2} className="text-gold uppercase tracking-[0.3em] text-sm mb-4 font-semibold">
            {t("accommodation.hero.subtitle")}
          </AnimatedText>
          <AnimatedTitle
            title={t("accommodation.hero.title")}
            className="text-4xl md:text-5xl lg:text-6xl font-luxury text-shadow-lg leading-tight mb-6 max-w-4xl mx-auto"
          />
        
          <AnimatedText delay={0.3}>
            <p className="text-white/80 max-w-3xl mx-auto text-lg leading-relaxed">
              {t("accommodation.hero.desc")}
            </p>
          </AnimatedText>
          
        </div>
      
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20">
          <button 
            onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
            className="text-white/70 hover:text-white transition-colors duration-300 flex flex-col items-center gap-2 cursor-pointer"
            aria-label="Scroll to content"
          >
            <span className="uppercase tracking-[0.2em] text-[10px]">{t("accommodation.hero.btnScroll")}</span>
            <ChevronDown size={24} className="animate-bounce" />
          </button>
        </div>
      </section>

      <section className="py-24 bg-background">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
            {villas.map((villa: any, i: number) => (
              <LuxuryCard
                key={villa.slug}
                title={villa.title}
                image={villa.image}
                href={`/accommodation/${villa.slug}`}
                description={villa.description}
                features={villa.features}
                delay={i * 0.1}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
